import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';

const initialState = fromJS({
    savingPotentials: {
        isLoading: false,
        data: []
    }
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // reports
        case CONSTANTS.ON_SAVING_POTENTIALS_LIST_IS_LOADING:
            return state.setIn(['savingPotentials', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_SAVING_POTENTIALS_LIST:
            return state.setIn(['savingPotentials', 'data'], payload.data);

        default:
            return state;
    }
};

export default reducer;
